/* ***************************************
This mixin "exposes" the methods:
  * getAdjacentParagraphWordIndex() [for NikudEdit]
  * moveToAdjacentLine() [for NikudEdit]
(all else should be considered "internal")
*************************************** */

import $ from 'jquery'
import styleGlobals from '../js/styleGlobals'

const LINE_DELTA = styleGlobals.MIN_FONT_SIZE - 5 // attempt to account for font size differences

export default {
  name: 'specialNavigationMixins',
  methods: {
    getLastPrevWordSepAfter (wordIndex) {
      return wordIndex > 1
        ? this.$store.state.allWorkingNikud.wordsArray[wordIndex - 1].sepAfter : ''
    },
    getAdjacentParagraphWordIndex (inc) {
      var found = false
      const currentWordIndex = this.$store.state.currentPositionData.wordIndex
      var wordIndex = currentWordIndex + inc
      var sepAfterToTest = inc > 0 ? this.$store.state.allWorkingNikud.wordsArray[currentWordIndex].sepAfter
        : this.getLastPrevWordSepAfter(wordIndex)
      const wordsArrayLength = this.$store.state.allWorkingNikud.wordsArray.length
      while (!found && wordIndex >= 0 && wordIndex < wordsArrayLength) {
        const wordObj = this.$store.state.allWorkingNikud.wordsArray[wordIndex]
        if ((sepAfterToTest + wordObj.sepBefore).includes('\n')) {
          found = true
        } else {
          sepAfterToTest = inc > 0 ? wordObj.sepAfter : this.getLastPrevWordSepAfter(wordIndex)
          wordIndex += inc
        }
      }
      const toMoveTo = found ? wordIndex : (inc > 0 ? wordsArrayLength - 1 : 0)
      // console.log('toMoveTo:')
      // console.log(toMoveTo)
      return toMoveTo
    },
    getPos (wordId, letterIndex, sepBeforeLength, letterArrayLength) {
      const span = (letterIndex < sepBeforeLength || letterIndex > (sepBeforeLength + letterArrayLength))
        ? $('#span-S-word-' + wordId + '-letterpos-' + letterIndex)
        : $('#span-L-word-' + wordId + '-letter-' + letterIndex)
      return span.position()
    },
    moveToAdjacentLine (inc) {
      var found = false
      const currentWordIndex = this.$store.state.currentPositionData.wordIndex
      var wordIndex = currentWordIndex
      const currentLetterIndex = this.$store.state.currentPositionData.letterIndex
      var letterIndex = currentLetterIndex
      var wordObj = this.$store.state.allWorkingNikud.wordsArray[wordIndex]
      var letterArray = wordObj.standardLetterArray
      var sepBeforeLength = wordObj.sepBefore.length
      const posToReach = this.getPos(wordObj.wordId, letterIndex, sepBeforeLength, letterArray.length)
      var previousPos = posToReach
      var reachedNextLine = false
      var totalLength = sepBeforeLength + letterArray.length + wordObj.sepAfter.length
      var previousTotalLength
      const wordsArrayLength = this.$store.state.allWorkingNikud.wordsArray.length
      while (!found && wordIndex >= 0 && wordIndex < wordsArrayLength) {
        letterIndex += inc
        if (letterIndex >= totalLength || letterIndex < 0) {
          wordIndex += inc
          letterIndex = 0
          if (wordIndex >= 0 && wordIndex < wordsArrayLength) {
            if (inc > 0) previousTotalLength = totalLength
            wordObj = this.$store.state.allWorkingNikud.wordsArray[wordIndex]
            letterArray = wordObj.standardLetterArray
            sepBeforeLength = wordObj.sepBefore.length
            totalLength = sepBeforeLength + letterArray.length + wordObj.sepAfter.length
          }
          letterIndex = inc < 0 ? totalLength - 1 : 0
        }
        if (wordIndex >= 0 && wordIndex < wordsArrayLength) {
          const pos = this.getPos(wordObj.wordId, letterIndex, sepBeforeLength, letterArray.length)
          // console.log('pos:')
          // console.log(pos)
          // console.log('posToReach:')
          // console.log(posToReach)
          var reachedNextLineThisTime = false // note that "next" means in whichever direction we're trying to go
          const previousPosPassed = inc > 0 
            ? previousPos.top < (pos.top - LINE_DELTA) : previousPos.top > (pos.top + LINE_DELTA)
          if (!reachedNextLine && previousPosPassed) reachedNextLineThisTime = true
          if (reachedNextLineThisTime) reachedNextLine = true
          const posLeftReached = inc > 0 ? pos.left < posToReach.left : pos.left > (posToReach.left - 10)
          if (reachedNextLine && posLeftReached) {
            found = true
          } else {
            if (inc > 0 && reachedNextLine && !reachedNextLineThisTime 
                && previousPos.top < (pos.top - LINE_DELTA)) {
              found = true
              letterIndex -= 1
              if (letterIndex < 0) {
                wordIndex -= 1
                letterIndex = previousTotalLength - 1
              }
            } else previousPos = pos
          }
        }
      }
      const wordToMoveTo = found ? wordIndex 
        : (inc > 0 ? wordsArrayLength - 1 : 0)
      const letterToMoveTo = found ? letterIndex : (inc > 0 ? totalLength - 1 : 0)
      const whetherMoving = wordToMoveTo !== currentWordIndex || letterToMoveTo !== currentLetterIndex
      if (whetherMoving) {
        this.$store.commit('SET_WORD_AND_LETTER', {
          word: wordToMoveTo,
          letter: letterToMoveTo
        })
      }
      return whetherMoving
    }
  }
}
